export default __webpack_public_path__ + "static/media/SEGA.b0ad707e.svg";